import React, {useEffect, useState} from "react";
import {TimeoutWarningModal} from "./TimeoutWarningModal"
import { addEventListeners,  removeEventListeners } from './util/eventListenerUtil'
import { useNavigate } from 'react-router-dom'
import useAuth from 'app/hooks/useAuth'
    
export const TimeoutLogic = () => { 
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);

  const navigate = useNavigate();
  const { logout, user } = useAuth()
  const [counter, setCounter] = useState(0);
  const timeout1period = 20 * 60 * 1000;
  const timeout2period = 2 * 1000;

  useEffect(() => {
    const createTimeout1 = () => setTimeout(()=>{ 
      setWarningModalOpen(true);
      setCounter(10);
    },timeout1period)

    const createTimeout2 = () => setTimeout(() => {
      // Implement a sign out function here
      // window.location.href = 'https://www.google.com.my/imghp?hl=en&authuser=0&ogbl'
      // navigate('/account/signin');
      logout()
    },timeout2period)

    const listener = () => {
      if(!isWarningModalOpen){
        clearTimeout(timeout)
        timeout = createTimeout1();
      }
    } 

    // Initialization
    let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1()
    addEventListeners(listener);

    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);

    // Cleanup
    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
      clearInterval(timer);
    }
  },[isWarningModalOpen,counter])
  return (
    <div>
      {isWarningModalOpen && (
        <TimeoutWarningModal 
          isOpen={isWarningModalOpen}
          onRequestClose={() => setWarningModalOpen(false)}
          countdown={counter}
        />
        )
      }
    </div>
  ) 
}